export default function Contact() {
  return (
    <section id="contact" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get In Touch
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Ready to experience a cleaner home? Reach out to us and we'll get back to you as soon as possible.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-stretch gap-3 sm:gap-4 max-w-xl mx-auto">
          <div className="flex-1 flex flex-col items-center text-center bg-gray-50 rounded-xl p-8">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-mail-line text-2xl text-teal-600"></i>
            </div>
            <div className="font-bold text-gray-900 text-lg mb-2">Email</div>
            <a
              href="mailto:karolay.ribeiro@hotmail.com"
              className="text-gray-600 hover:text-teal-600 transition-colors text-sm sm:text-base"
            >
              karolay.ribeiro@hotmail.com
            </a>
          </div>

          <div className="flex-1 flex flex-col items-center text-center bg-gray-50 rounded-xl p-8">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-phone-line text-2xl text-teal-600"></i>
            </div>
            <div className="font-bold text-gray-900 text-lg mb-2">Phone</div>
            <a
              href="tel:+18603785186"
              className="text-gray-600 hover:text-teal-600 transition-colors text-sm sm:text-base"
            >
              (860) 378-5186
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
